import { onKonfigImagesApplied } from './_konfig.js';

// https://github.com/biati-digital/glightbox
import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';


//standard lightbox
const lightbox = GLightbox();

onKonfigImagesApplied(() => {
    if (!lightbox || typeof lightbox.getElements !== 'function') {
        return;
    }
    const elements = lightbox.getElements();
    if (!Array.isArray(elements)) {
        lightbox.elements = elements;
        return;
    }
    lightbox.elements = elements.filter((item) => {
        const node = item && item.node;
        if (!node || typeof node.closest !== 'function') {
            return true;
        }
        return !node.closest('[hidden]');
    });
});

//search box header
$(document).ready(function() {

    const searchbox = GLightbox({
        touchNavigation: false,
        touchFollowAxis: false,
        keyboardNavigation: false,
        selector: ".searchboxlink",
        zoomable: false,
        draggable: false,
        height: 'auto'
    });
    searchbox.on('open', () => {
        $('input[type="search"]').select();
        $('.button--close').click(function() {
            searchbox.close();
        })
    });

});
